import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../axiosAuth";
import { SCHOOL_LAB_POC_CREATE } from "./apiRoutes";

export interface LabPocItemPayload {
  // schoolId: string;
  pocName: string;
  pocPhone: string;
  pocEmail: string;
  pocDesignation: string;
}

export interface CreateSchoolLabPocPayload {
  schoolId: string;
  pocList: LabPocItemPayload[];
}

export interface CreateSchoolLabPocResponse {
  data?: unknown;
  message?: string;
}

export const useCreateSchoolLabPocMutation = (options?: { onSuccess?: () => void }) => {
  return useMutation({
    mutationFn: async (payload: CreateSchoolLabPocPayload) => {
      const response = await axiosAuth.post<CreateSchoolLabPocResponse>(
        SCHOOL_LAB_POC_CREATE,
        payload
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Lab POC saved successfully");
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.issues?.message || error?.response?.data?.message || "Failed to save Lab POC";
      toast.error(message);
    },
  });
};


